import React from 'react';
import { instanceOf, string, number, bool, func } from 'prop-types';
import { List } from 'immutable';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { OverlayTrigger, Popover } from 'react-bootstrap';

import CodeModal from '../CodeModal';
import CodeModalToggle from '../CodeModalToggle';
import PaginationButtons from '../PaginationButtons';

import STYLES from './Transactions.module.scss';

const truncateString = hash => `${hash.substring(0, 14)}...`;
const transactionPopOver = hash => (
  <Popover id="transaction-hash">{hash}</Popover>
);

const determineOrder = (transactions, transactionsOrder) =>
  transactionsOrder === 'asc' ? transactions.reverse() : transactions;

const Transactions = ({
  transactions,
  currentPage,
  transactionsOrder,
  isMoreTransactions,
  isFetchingTransactions,
  toggleCodeModal,
  isDevModeOn,
  onGetNextPage,
  onGetPreviousPage,
}) => (
  <div className={STYLES.Transactions}>
    {isFetchingTransactions ? (
      <div>
        <div className="loading-spinner-animation" />
      </div>
    ) : (
      <div>
        {transactions && transactions.size ? (
          <div>
            {determineOrder(transactions, transactionsOrder).map(
              transaction => (
                <div
                  className={STYLES.transactionRow}
                  key={transaction.get('id')}>
                  <div className={STYLES.transactionItem}>
                    <div className={STYLES.titleContainer}>
                      <h4>
                        <Link to={`/transactions/${transaction.get('hash')}`}>
                          <OverlayTrigger
                            placement="top"
                            overlay={transactionPopOver(
                              transaction.get('hash')
                            )}>
                            <span>
                              TRANSACTION -{' '}
                              {truncateString(transaction.get('hash'))}
                            </span>
                          </OverlayTrigger>
                        </Link>
                        {isDevModeOn && (
                          <CodeModalToggle
                            id={transaction.get('id')}
                            toggleCodeModal={toggleCodeModal}
                            buttonSize="small"
                          />
                        )}
                      </h4>
                      <div className={STYLES.label}>
                        LEDGER {transaction.get('ledger_attr')}
                      </div>
                    </div>
                    <p className={STYLES.date}>
                      Created:{' '}
                      {moment(transaction.get('created_at')).format('LLL')}
                    </p>
                    <div className={STYLES.flexDetails}>
                      Applied to{' '}
                      <Link to={`/ledgers/${transaction.get('ledger_attr')}`}>
                        Ledger{transaction.get('ledger_attr')}
                      </Link>{' '}
                      with {transaction.get('operation_count')}{' '}
                      {transaction.get('operation_count') > 1
                        ? 'operations'
                        : 'operation'}{' '}
                      contained at a fee of {transaction.get('fee_paid')}.
                    </div>
                  </div>
                  {isDevModeOn && (
                    <CodeModal name="transaction" code={transaction} />
                  )}
                </div>
              )
            )}
            <PaginationButtons
              section="Transactions"
              currentPage={currentPage}
              isMoreItems={isMoreTransactions}
              onGetNextPage={onGetNextPage}
              onGetPreviousPage={onGetPreviousPage}
            />
          </div>
        ) : (
          <div className={STYLES.noTransactions}>
            <div className={STYLES.largeLabel}>
              There are no Transactions for this item yet.
            </div>
          </div>
        )}
      </div>
    )}
  </div>
);

Transactions.propTypes = {
  transactions: instanceOf(List),
  transactionsOrder: string,
  currentPage: number,
  isDevModeOn: bool,
  isFetchingTransactions: bool,
  isMoreTransactions: bool,
  toggleCodeModal: func.isRequired,
  onGetNextPage: func,
  onGetPreviousPage: func,
};

Transactions.defaultProps = {
  transactionsOrder: 'desc',
  currentPage: 1,
  isDevModeOn: false,
  isMoreTransactions: false,
  isFetchingTransactions: false,
  onGetNextPage: () => {},
  onGetPreviousPage: () => {},
};

export default Transactions;
